import { adminSchema as mikraSchema } from '@mikra/validation';
import { adminSchema as partnerScehma } from '@partner/validation';
import { adminSchema as partnermkdScehma } from '@partnermkd/validation';

export const adminSchema = process.env.REACT_APP_CLIENT === 'mikra' ? mikraSchema : process.env.REACT_APP_CLIENT === 'partner' ? partnerScehma : partnermkdScehma;

